import { render, staticRenderFns } from "./WriterWeek.vue?vue&type=template&id=2ea0a420&scoped=true"
import script from "./WriterWeek.vue?vue&type=script&lang=js"
export * from "./WriterWeek.vue?vue&type=script&lang=js"
import style0 from "./WriterWeek.vue?vue&type=style&index=0&id=2ea0a420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea0a420",
  null
  
)

export default component.exports